import React from 'react'
import ProfileInfoForm from '../../components/ProfileInfoForm/ProfileInfoForm'
import ProfilePasswordForm from '../../components/ProfilePasswordForm/ProfilePasswordForm'
import { Card, Tabs, Typography } from 'antd'
import { Profile } from '../../services/models'
import ProfileAvatarForm from '../../components/ProfileAvatarForm/ProfileAvatarForm'
import SubscriptionForm from '../../components/SubscriptionForm/SubscriptionForm'
import { useAppSelector } from '../../app/hooks'
import { permItems } from '../../features/perm/permSlice'
import { Helmet } from 'react-helmet-async'

type Props = {
    profile: Profile;
}

const ProfilePage: React.FC<Props> = ({ profile }) => {
  const permissions = useAppSelector(permItems)
  const tabs = [
    {
      label: 'Информация',
      key: '1',
      children: <ProfileInfoForm
                firstName={profile.firstName}
                lastName={profile.lastName}
                biography={profile.biography}
                job={profile.job}
                role={profile.role}
                contactEmail={profile.contactEmail}/>
    },
    {
      label: 'Фото',
      key: '2',
      children: <ProfileAvatarForm userId={profile.id}/>
    },
    {
      label: 'Пароль',
      key: '3',
      children: <ProfilePasswordForm/>
    },
    {
      label: 'Подписки',
      key: '4',
      children: <SubscriptionForm permissions={permissions} profile={profile}/>
    }
  ]

  // Отступы и белая подложка принадлежат PageShell. Формы сами задают свою
  // ширину, поэтому фиксированный maxWidth здесь лишь прижимал профиль влево.
  return (
      <Card style={{ margin: '5px' }}>
        <Helmet><title>Prisma — Профиль</title></Helmet>
        <Typography.Title>Профиль пользователя</Typography.Title>
        <Tabs
            defaultActiveKey="1"
            items={tabs}
        />
      </Card>
  )
}

export default ProfilePage
